<img
  *ngIf="currentUserType !== userType.user"
  src="assets/images/3devices-sm.png"
  alt="Purposeful shown on a tablet, laptop, and phone" />

<!-- Header -->
<h1 *ngIf="currentUserType !== userType.user && !isMobile">Ready to build a better you?</h1>
<h1 *ngIf="currentUserType !== userType.user && isMobile">Welcome to {{ productName }}!</h1>

<!-- Description -->
<p *ngIf="currentUserType !== userType.user && !isMobile">
  Purposeful is a
  <strong>simple</strong>
  yet
  <strong>powerful</strong>
  app designed to help you harness
  <strong>brain science</strong>
  to find and live your purpose while becoming the best version of you.
</p>

<!-- Call to Action -->
<ng-container *ngIf="currentUserType !== userType.user">
  <p>Get started today by creating your free account in just a few minutes.</p>
  <button class="button button-pill thank-you-button" (click)="getStarted()">Get Started</button>
  <ng-container *ngIf="isMobile">
    <p class="or">or</p>
    <button class="continue-link" (click)="continueOnboarding()" [disabled]="transitionToOnboarding">
      Continue on the web
    </button>
  </ng-container>
</ng-container>
